import React, { useEffect, useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';

const NAV_LINKS = [
  { label: 'Home',     path: '/'         },
  { label: 'About',    path: '/about'    },
  { label: 'Services', path: '/services' },
  { label: 'Works',    path: '/works'    },
  { label: 'Contact',  path: '/contact'  },
  { label: 'Proposal', path: '/proposal' },
];

const Header = () => {
  const [open,    setOpen]    = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const history  = useHistory();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Close overlay on route change
  useEffect(() => { setOpen(false); }, [location.pathname]);

  // Prevent body scroll when overlay is open
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  const handleLogoClick = (e) => {
    e.preventDefault();
    history.push('/');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <header className={`nf-header${scrolled ? ' nf-header--scrolled' : ''}`}>
        <a href="/" className="nf-header__logo" onClick={handleLogoClick}>
          nafas
        </a>
        <button
          className={`nf-burger${open ? ' nf-burger--open' : ''}`}
          onClick={() => setOpen((o) => !o)}
          aria-label={open ? 'Close menu' : 'Open menu'}
          aria-expanded={open}
        >
          <span className="nf-burger__line nf-burger__line--1" />
          <span className="nf-burger__line nf-burger__line--2" />
          <span className="nf-burger__line nf-burger__line--3" />
        </button>
      </header>

      <div
        className={`nf-overlay${open ? ' nf-overlay--open' : ''}`}
        role="dialog"
        aria-modal="true"
        aria-label="Navigation"
      >
        <nav className="nf-overlay__nav">
          {NAV_LINKS.map(({ label, path }) => (
            <Link
              key={path}
              to={path}
              className="nf-overlay__link"
              onClick={() => setOpen(false)}
            >
              {label}
            </Link>
          ))}
          <div className="nf-overlay__socials">
            <a
              href="https://instagram.com/nafarch"
              target="_blank"
              rel="noopener noreferrer"
              className="nf-overlay__social-link"
            >
              Instagram
            </a>
            <a
              href="https://facebook.com/nafarch"
              target="_blank"
              rel="noopener noreferrer"
              className="nf-overlay__social-link"
            >
              Facebook
            </a>
          </div>
        </nav>
      </div>
    </>
  );
};

export default Header;
